// @ts-nocheck
export function expandCollapsedRow({ setDateChangedIdx, row, dpName }) {
  setDateChangedIdx((prev) => ({
    ...prev,
    [row?.session?._id]: {
      ...(prev?.[row?.session?._id] || {}),
      [dpName]: {
        ...prev[row?.session?._id]?.[dpName],
        status: false,
      },
    },
  }));
}

export function collapseExpandedRow({ setDateChangedIdx, row, dpName }) {
  setDateChangedIdx((prev) => ({
    ...prev,
    [row?.session?._id]: {
      ...(prev?.[row?.session?._id] || {}),
      [dpName]: {
        ...prev[row?.session?._id]?.[dpName],
        status: true,
      },
    },
  }));
}